import React from 'react'
import { Dialog } from 'primereact/dialog';
import { Chart } from 'primereact/chart';
import isMobile from 'is-mobile';     
import ChartDataLabels from 'chartjs-plugin-datalabels';  
import { Avatar } from 'primereact/avatar';
import { buildDriverChartSeries } from './chart_data';

function getFlagEmoji(nationality) {
  const flags = {
    italia: 'IT',
    italy: 'IT',
    francia: 'FR',
    france: 'FR',
    spagna: 'ES',
    spain: 'ES',
    germania: 'DE',
    germany: 'DE',
    'regno unito': 'GB',
    'united kingdom': 'GB',
    uk: 'GB',
    'gran bretagna': 'GB',
    usa: 'US',
    'stati uniti': 'US',
    'united states': 'US',
  }

  const code = flags[(nationality || '').toLowerCase()]
  if(!code) return ''

  return code
    .toUpperCase()
    .split('')
    .map((char) => String.fromCodePoint(127397 + char.charCodeAt(0)))
    .join('')
}

function DriverInfo(props) {
  let info = props.info
  let setInfo = props.setInfo
  let race_names = props.races
  let max = props.max
  let nationalityFlag = getFlagEmoji(info?.['nationality'])
  let chartMax = Math.max(1, Math.trunc(max + (max/10)))
  let results = info?.['results'] || []
  let { pointsData, dnpData } = buildDriverChartSeries(results)

  return (
    <>
    {
      info == null ? "" :
      <Dialog closeOnEscape dismissableMask className="m-0" header="Informazioni pilota" visible={info != null} position={"bottom"}  onHide={() => setInfo(null)} draggable={false} style={{maxWidth: "100%", width: isMobile() ? "100vw" : "60vw"}}>
        <div> 
          <div className="grid">
            {
              !info['image'] ?  
              <div className="col-12 col-md-4 md:col-4 flex align-content-center">
                <Avatar label={(info['name'] || '?').charAt(0).toUpperCase()} size="xlarge" shape="circle" style={{backgroundColor: "#e9ecef", color: "#495057", width: 200, height: 200, margin: "auto", fontSize: "4rem"}} />
              </div> :
              <div className="col-12 col-md-4 md:col-4 flex align-content-center">
                <img alt="" className="m-auto" src={info['image']} style={{width: 200, height: 200, borderRadius: "100%"}} />
              </div>
            }
            <div className="col-7 col-md-7 md:col-7">
              <h1 className="mb-1 mt-0">
                <span className="mr-2" style={{
                  color: "red",
                  borderLeft: "4px solid red",
                  paddingLeft: 5
                }}>{info['position']}</span>
                {info['name']} - {info['driver_number']}
              </h1>
              <div className="grid mt-2">
                <div className="col-12 md:col-6 col-md-6">
                  <h4 className="mb-1">Team</h4>
                  <p className="mt-0">{info['team']}</p>
                  <h4 className="mb-1 mt-3">Marca</h4>
                  <div className="flex align-items-center gap-2">
                    {
                      info['brand_image']
                        ? <img alt="" src={info['brand_image']} style={{width: 36, height: 36, borderRadius: 18, objectFit: "cover"}} />
                        : <Avatar label={(info['brand'] || '?').charAt(0).toUpperCase()} size="normal" shape="circle" style={{backgroundColor: "#e9ecef", color: "#495057"}} />
                    }
                    <span>{info['brand'] || '-'}</span>
                  </div>
                </div>
                <div className="col-12 md:col-6 col-md-6">
                  <h4 className="mb-1 ">Data di nascita</h4>
                  <p className="mt-0 mb-1">{info['birthday']}</p>
                  <h4 className="mb-1 mt-3">Nazionalità</h4>
                  <p className="mt-0 mb-0">{nationalityFlag ? `${nationalityFlag} ` : ''}{info['nationality'] || '-'}{info['province'] ? ` - ${info['province']}` : ''}</p>
                </div>
              </div>
            </div>
          </div>
          <h3>Risultati</h3>
          <div style={{height: 320}}>
          <Chart
            type="line"
            plugins={[ChartDataLabels]}
            data={{
              labels: race_names,
              datasets: [
                {
                  label: "Punti",
                  data: pointsData,
                  tension: 0.4,
                  borderWidth: 1.7,
                  spanGaps: false,
                  pointBorderColor: "white",
                  pointBackgroundColor: "purple"
                },
                {
                  label: "DNP",
                  data: dnpData,
                  isDnpDataset: true,
                  showLine: false,
                  pointRadius: 5,
                  pointBorderColor: "white",
                  pointBackgroundColor: "#6c757d"
                }
              ]
            }}
            options={{
              maintainAspectRatio: false,
              aspectRatio: 1, 
              plugins: {
                legend: { display: false },
                datalabels: {
                  // anchor: 'end',
                  align: 'end',
                  color: 'white',
                  backgroundColor: (context) => context.dataset.isDnpDataset ? "#6c757d" : "purple",
                  borderRadius: 5,
                  clamp: true,
                  formatter: (value, context) => context.dataset.isDnpDataset ? "DNP" : value,
                  font: {
                    size: 13,
                  },
                },
                tooltip: {
                  callbacks: {
                    label: (context) => context.dataset.isDnpDataset ? "DNP" : `Punti: ${context.raw}`,
                  },
                },
              },
              scales: {
                y: {
                  min: 0,
                  max: chartMax
                }
              }
            }}/>
          </div>
        </div>
      </Dialog>
      }
    </>
  )
}

export default DriverInfo
